import { NavLink } from "react-router-dom";

const NAV_ITEMS = [
  { to: "/", label: "数据总览", icon: "ri-dashboard-3-line", end: true },
  { to: "/domains", label: "域名管理", icon: "ri-global-line", end: false },
  { to: "/analytics", label: "访问统计", icon: "ri-bar-chart-2-line", end: false },
  { to: "/settings", label: "系统设置", icon: "ri-settings-3-line", end: false },
];

export default function Sidebar() {
  return (
    <aside className="hidden w-64 shrink-0 flex-col bg-foreground-950 lg:flex">
      <div className="flex items-center gap-3 px-6 py-6">
        <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-primary-500 text-background-50">
          <i className="ri-route-line text-xl" />
        </span>
        <div className="leading-tight">
          <p className="font-heading text-sm font-semibold text-background-50">中转站后台</p>
          <p className="text-xs text-foreground-400">Domain Relay Console</p>
        </div>
      </div>

      <nav className="mt-2 flex flex-1 flex-col gap-1 px-3">
        {NAV_ITEMS.map((item) => (
          <NavLink
            key={item.to}
            to={item.to}
            end={item.end}
            className={({ isActive }) =>
              `flex items-center gap-3 rounded-md px-3 py-2.5 text-sm transition-colors cursor-pointer ${
                isActive
                  ? "bg-primary-500 font-medium text-background-50"
                  : "text-foreground-300 hover:bg-foreground-900 hover:text-background-50"
              }`
            }
          >
            <i className={`${item.icon} text-lg`} />
            {item.label}
          </NavLink>
        ))}
      </nav>

      <div className="mx-3 mb-5 rounded-lg bg-foreground-900 p-4">
        <div className="flex items-center gap-2 text-background-50">
          <i className="ri-shield-check-line text-accent-400" />
          <span className="text-xs font-medium">跳转服务运行正常</span>
        </div>
        <p className="mt-2 text-xs leading-relaxed text-foreground-400">
          访问已解析到本服务的域名时，会直接按规则跳转。
        </p>
      </div>
    </aside>
  );
}